module.exports = {"431322100":"上梅镇","431322101":"石冲口镇","431322102":"洋溪镇","431322103":"槎溪镇","431322104":"水车镇","431322105":"文田镇","431322106":"奉家镇","431322107":"炉观镇","431322108":"游家镇","431322109":"西河镇","431322110":"孟公镇","431322111":"琅塘镇","431322112":"白溪镇","431322113":"圳上镇","431322114":"吉庆镇","431322115":"温塘镇","431322116":"田坪镇","431322117":"桑梓镇","431322118":"曹家镇","431322200":"科头乡","431322201":"维山乡","431322202":"天门乡","431322203":"荣华乡","431322204":"金凤乡","431322205":"油溪乡","431322206":"坐石乡","431322450":"上渡","431322500":"大熊山国有林场","431322501":"古台山国有林场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/431322.json
// module id = 1763
// module chunks = 0